export const useDefaultData = ({helpers}) => {

    const {getCurrentDate} = helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormLease = {
        idcontrato: 0,
        idcasa: '',
        idcliente: '',
        contrato_fecha: getCurrentDate(),
        contrato_dia_pago: '',
        contrato_plazo_meses: '',
        contrato_costo_alquiler: '',
        contrato_costo_alquiler_mask: '',
        contrato_total_alquiler: '',
        contrato_total_alquiler_mask: '',
        contrato_papeleria: '',
        contrato_papeleria_mask: '',
        contrato_deposito: '',
        contrato_deposito_mask: '',
        contrato_observaciones: '',
        
        // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_observaciones: ''

    }

    const defaultFormFiles = {
        idcontrato: '',
        files :[],
        acceptedFiles: [],
        fileRejections: []
    }


    const defaultFormDeposit = {
        iddeposit: '',
        idcaja: '',
        idbanco: '',
        deposito_fecha: getCurrentDate(),
        deposito_monto: '',
        deposito_monto_mask: '',
        deposito_moneda: '',
        deposito_tipo_cambio: 7.8,
        deposito_quetzales: '',
        deposito_quetzales_mask: '',
        deposito_dolares: '',
        deposito_dolares_mask: '',
        deposito_observaciones: '',
        movimiento_tipo: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_check: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionCheck = [
        { value: 'PENDIENTE CONTRATO', label: 'PENDIENTE CONTRATO' },
        { value: 'PENDIENTE APROBACION', label: 'PENDIENTE APROBACION' },
        { value: 'DEVUELTO A JURIDICO', label: 'DEVUELTO A JURIDICO' },
        { value: 'DEVUELTO A GESTOR', label: 'DEVUELTO A GESTOR' },
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];

    const defaultObservationsForm = {
        idcontrato: '',
        log_observacion: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormDeposit,
        defaultFormFiles,
        defaultFormLease,
        optionsAprobacionCheck,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
        defaultObservationsForm
    })
}